// Brand
export const BRAND = "Co Mann Beats";
export const LOGO_URL = "https://customer-assets-4nw71qhi.emergentagent.net/job_beat-marketplace-78/artifacts/prvekwdn_Webp.net-resizeimage%20%286%29.webp";

// Genre categories for the catalog / upload dropdown.
export const GENRES = [
  "Hip Hop",
  "Trap",
  "R&B",
  "Drill",
  "Pop",
  "Rock",
  "Afrobeat",
  "Reggaeton",
  "Lo-Fi",
  "Drum & Bass",
  "House",
  "Synthwave",
  "Boom Bap",
  "Other",
];

// Contact email shown in the footer.
export const CONTACT_EMAIL = "comannbeats@gmail.com";
